import { useMutation } from "@tanstack/react-query";
import { OpenapiSingleton } from "src/utils/OpenapiSingleton";
import { useShop } from "src/hooks/Utils/Shop/useShop";
import { FavoriteIdListDto } from "src/api/customer";
import { queryClient } from "src/utils/init/queryClient";;

export default function useMyFavoriteAddMutation() {
  
  const { shopLang, shopMarketId } = useShop();

  const addFavoriteProductMutation = async (favoriteProductsIds: FavoriteIdListDto) => {
    return await OpenapiSingleton.BuyerFavoritesApiApi.addFavoriteProduct(
      shopMarketId,
      favoriteProductsIds,
      shopLang,
    );
  };
    
  return useMutation({
    mutationFn: addFavoriteProductMutation,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [
          "getMyFavoriteProductById",
          variables?.productIds[0],
        ],
      });
    },
  });
}